export interface Company {
  name: string;
  logo?: string;
  website?: string;
  className?: string;
}

export interface Mentor {
  id: string;
  name: string;
  image: string;
  description?: string;
  detailedDescription: string;
  expertise?: string[];
  location?: string;
  languages?: string[];
  price?: string[];
  website?: string;
  phoneNumber?: string;
  email?: string;
  stages?: string[];
  shortDescription?: string;
  linkedIn?: string;
  twitter?: string;
  showOnMobile?: boolean;
  companies?: Company[];
  linkedInCover?: string;
}

export const mentors: Mentor[] = [
  {
    id: 'mehdi-benkirane',
    name: 'Mehdi Benkirane',
    image: '/assets/mehdi.webp',
    description:
      'Strategic advisor for game studios in business development and funding opportunities.',
    detailedDescription: `Drawing from his extensive experience since 2009 in the games industry, Mehdi offers strategic guidance in business development and studio growth. His background spans mentoring students, representing 12 studios as an agent, and leading business development for a Ubisoft-owned game hosting company. Through his consulting company, he helps studios make strategic decisions and secure opportunities in work-for-hire, co-development, and funding/publishing agreements.`,
    expertise: ['Business & Strategy'],
    location: 'Aalsmeer, The Netherlands',
    languages: ['English', 'French'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '',
    email: 'mehdi@zenithpirates.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Running my own game strategy and business consulting company',
    linkedIn: 'http://linkedin.com/in/mehdibenkirane',
    twitter: '',
    showOnMobile: true,
    companies: [
      {
        name: 'Zenith Pirates',
        logo: 'zenith-pirates.webp',
        website: 'https://zenithpirates.com',
      },
    ],
  },
  {
    id: 'michiel-houwen',
    name: 'Michiel Houwen',
    image: '/assets/michiel.webp',
    description: 'Acceleration program manager helping indie studios overcome funding challenges.',
    detailedDescription: `As a seasoned acceleration program manager and gaming industry coach, Michiel specializes in helping indie game studios overcome funding challenges and maximize their potential. His years of experience in setting up incubation and acceleration programs, combined with his extensive industry network, make him an invaluable mentor for studios seeking to navigate their early stages of development.`,
    expertise: ['Business & Strategy', 'Marketing & Community'],
    location: 'Kortrijk, Belgium',
    languages: ['Dutch', 'English'],
    price: ['Free'],
    website: '', // Removing because identical to LinkedIn
    phoneNumber: '',
    email: 'michiel@flandersgamehub.be',
    stages: ['Startup'],
    shortDescription: 'Indie Consultant, Program Manager Flanders Game Hub and Mgmt ForsVC',
    linkedIn: 'https://www.linkedin.com/in/michielhouwen/',
    twitter: '',
    showOnMobile: false,
    companies: [
      {
        name: 'ForsVC',
        logo: 'forsvclogo.webp',
        website: 'https://fors.vc', // Replace with actual website if available
      },
      {
        name: 'Flanders Game Hub',
        logo: 'flandersgamehublogo.svg',
        website: 'https://flandersgamehub.be',
        className: 'grayscale invert pt-2',
      },
    ],
  },
  {
    id: 'oscar-clark',
    name: 'Oscar Clark',
    image: '/assets/oscar.webp',
    description:
      'Pioneer in mobile games and live services, expert in Games as a Service monetization.',
    detailedDescription: `A pioneer in mobile and connected games since 1998, Oscar brings deep expertise in monetization and live services to his mentoring practice. His experience includes running BT's online games platform Wireplay and leading Hutchison Whampoa's mobile games team. As the author of "Games as a Service" (2014) and an international speaker, he offers invaluable insights into modern game monetization strategies and service-based gaming.`,
    expertise: ['Game Design & Creative', 'Business & Strategy'],
    location: 'London, United Kingdom',
    languages: ['English'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '',
    email: 'oscar@oscarclark.net',
    stages: ['Growth', 'Mature'],
    shortDescription: 'CEO Fundamentally Games, writer of Games as a Service',
    linkedIn: 'https://www.linkedin.com/in/oscarclark/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'sebastien-borget',
    name: 'Sebastien Borget',
    image: '/assets/sebastien.webp',
    description: 'Blockchain and mobile gaming expert with 14 years of entrepreneurial experience.',
    detailedDescription: `With 14 years of entrepreneurial experience, including 4 years in blockchain and 11 years in mobile gaming, Sebastien offers unique insights into emerging gaming technologies. As co-founder of Sandbox and President of the Blockchain Game Alliance, he helps developers understand and navigate the intersection of gaming and blockchain technology. His international speaking engagements and leadership role make him well-positioned to guide projects exploring innovative gaming platforms.`,
    expertise: ['Game Design & Creative', 'Technology & Development'],
    location: 'Paris, France',
    languages: ['English', 'French'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '',
    email: 'sebastien@borget.info',
    stages: [],
    shortDescription: 'President of the Blockchain Game Alliance and COO of Sandbox',
    linkedIn: 'https://www.linkedin.com/in/borgetsebastien/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'bram-van-lith',
    name: 'Bram van Lith',
    image: '/assets/bram.webp',
    description:
      'Marketing strategist specializing in PR, business development, and community management.',
    detailedDescription: `As Co-Founder of Game Drive, Bram specializes in crafting comprehensive marketing strategies for game developers. His expertise covers the full spectrum of game marketing, from PR and business development to community management and social media. He offers practical guidance in developing and executing marketing strategies that help games stand out in a competitive market.`,
    expertise: ['Marketing & Community'],
    location: 'Utrecht, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://www.game-drive.nl/',
    phoneNumber: '',
    email: 'bram@game-drive.nl',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Expert in tailor made game marketing',
    linkedIn: 'https://www.linkedin.com/in/bramvanlith/',
    twitter: 'https://x.com/GameDriveNL',
    showOnMobile: false,
  },
  {
    id: 'federica-nocerino',
    name: 'Federica Nocerino',
    image: '/assets/federica.webp',
    description:
      'Advocate for inclusivity in tech, specializing in strategic marketing and community building.',
    detailedDescription: `Federica is a passionate advocate for inclusivity in the tech and gaming industries, serving as the first Womentechmaker Ambassador in Brussels. She combines her marketing expertise with a deep commitment to fostering inclusive tech communities. Her experience spans strategic marketing, community building, and event facilitation, making her an ideal mentor for those seeking to create more inclusive and welcoming gaming spaces.`,
    expertise: ['Marketing & Community'],
    location: 'Brussels, Belgium',
    languages: ['English'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '',
    email: 'im.federica.nocerino@gmail.com',
    stages: [],
    shortDescription: 'Marketing and tech marketing consultant',
    linkedIn: 'https://www.linkedin.com/in/federicanocerino/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'robby-bisschop',
    name: 'Robby Bisschop',
    image: '/assets/robby.webp',
    description: 'Marketing and PR strategist helping developers optimize their store presence.',
    detailedDescription: `Robby offers practical, no-obligation guidance on game marketing and PR strategies. His expertise helps developers optimize their store pages, craft effective press kits, and develop social media presence. Through his focused 30-minute sessions, he provides actionable insights that can immediately improve a game's marketing approach.`,
    expertise: ['Marketing & Community'],
    location: 'Dendermonde, Belgium',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://piratepr.com',
    phoneNumber: '',
    email: 'robby@piratepr.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Free "pick my brain" about any PR/marketing related topic',
    linkedIn: '',
    twitter: 'https://x.com/PR_pirate',
    showOnMobile: false,
  },
  {
    id: 'paul-hanraets',
    name: 'Paul Hanraets',
    image: '/assets/paul.webp',
    description: 'Expert in publishing, investment, and business strategy for game studios.',
    detailedDescription: `Paul brings extensive expertise in creative and commercial gaming as a successful entrepreneur and publisher. As co-founder of Good Shepherd Entertainment and Mystic Forge, and pioneer of one of the first game-focused crowd-financing platforms, he offers valuable insights into publishing, investment, and business strategy. His track record makes him particularly well-suited to guide developers through the complexities of game publishing and funding.`,
    expertise: ['Business & Strategy'],
    location: 'Utrecht, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://mysticforge.com/',
    phoneNumber: '',
    email: 'paul@mysticforge.com',
    stages: [],
    shortDescription: 'Co-founder of Good Shepherd and Mystic Forge. Expert in publishing.',
    linkedIn: 'https://www.linkedin.com/in/paul-hanraets-89bba61/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'rami-ismail',
    name: 'Rami Ismail',
    image: '/assets/rami.webp',
    description: 'Industry veteran with expertise in independent game development and tools.',
    detailedDescription: `A highly respected figure in independent game development, Rami brings over two decades of experience creating successful games across all platforms. As co-founder of Vlambeer and creator of industry-standard tools like dopresskit.com, he combines practical development expertise with deep industry knowledge. His commitment to fostering a fairer, more accessible industry makes him an ideal mentor for developers seeking to navigate both technical and business challenges.`,
    expertise: ['Business & Strategy', 'Marketing & Community'],
    location: 'Hilversum, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://ramiismail.com/',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Games Industry Studio & Project Advisor, Indie Game Developer.',
    linkedIn: 'https://www.linkedin.com/in/ramiismail/',
    email: 'info@ramiismail.com',
    showOnMobile: true,
  },
  {
    id: 'vernon-vrolijk',
    name: 'Vernon Vrolijk',
    image: '/assets/vernon.webp',
    description: 'Marketing expert in global distribution strategies and business development.',
    detailedDescription: `Vernon leverages his decade of experience in gaming industry marketing and business development to help studios grow. His background as Marketing Director at Good Shepherd Entertainment and co-founder of Mystic Forge gives him unique insights into global marketing and distribution strategies. As an active member of the independent developer community and frequent industry speaker, he offers practical guidance in building successful marketing and partnership strategies.`,
    expertise: ['Marketing & Community'],
    location: 'Stockholm, Sweden',
    languages: ['English'],
    price: ['Free', 'Paid'],
    phoneNumber: '+46702212975',
    email: 'vernon.vrolijk@gmail.com',
    stages: ['Growth', 'Startup'],
    shortDescription: '10+ years of experience in the gaming industry, focused on Marketing',
    linkedIn: 'https://www.linkedin.com/in/vernon-vrolijk-158b4438',
    showOnMobile: false,
  },
  {
    id: 'martijn-van-zwieten',
    name: 'Martijn van Zwieten',
    image: '/assets/martijn.webp',
    description: 'Business coach specializing in PR, marketing, and operations for game companies.',
    detailedDescription: `With extensive experience in PR, marketing, business development, and operations, Martijn helps founders build better video game companies. His Executive MBA background combined with hands-on industry experience enables him to provide actionable coaching and strategic insights tailored to the games industry. He specializes in helping ambitious founders transform their creative vision into successful business ventures.`,
    expertise: ['Production & Management', 'Business & Strategy'],
    location: 'Utrecht, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://www.martijnvanzwieten.com',
    phoneNumber: '+31640882174',
    email: 'martijn@martijnvanzwieten.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'I help ambitious founders build better videogame companies',
    linkedIn: 'https://www.linkedin.com/in/mvanzwieten/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'kevin-haelterman',
    name: 'Kevin Haelterman',
    image: '/assets/kevin.webp',
    description: 'Studio founder with expertise in game development and community building.',
    detailedDescription: `As founder of LuGus Studios, known for the market-leading Liftoff drone simulator franchise, Kevin brings practical experience in building successful game studios. He combines his expertise in creating innovative gaming experiences with a passion for mentoring and community building. His active involvement in funding initiatives makes him particularly valuable for studios seeking guidance on growth and development.`,
    expertise: ['Production & Management', 'Business & Strategy'],
    location: 'Hasselt, Belgium',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '',
    email: 'kevin@lugus-studios.be',
    stages: ['Startup'],
    shortDescription: 'Co-Founder & Business Developer at LuGus Studios',
    linkedIn: 'https://www.linkedin.com/in/kevin-haelterman-a0699a6/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'geoff-van-den-ouden',
    name: 'Geoff van den Ouden',
    image: '/assets/geoff.webp',
    description: 'Executive Producer scaling game studios while maintaining quality.',
    detailedDescription: `With over 25 years in the Creative and Tech industries, Geoff brings extensive leadership experience as an Executive Producer and Studio Lead. His success in growing the We Were Here game series team from six to over 40 people demonstrates his ability to scale studios while maintaining quality. His diverse experience in Location-Based VR, Educational Technology, and Custom Software Development, combined with his talent for communicating across disciplines, makes him particularly valuable for teams seeking to grow while maintaining creative excellence.`,
    expertise: ['Production & Management'],
    location: 'Rotterdam, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Paid'],
    website: 'https://geoffvandenouden.com/',
    phoneNumber: '',
    email: 'geoff@geoffvandenouden.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Executive Producer & Studio Lead',
    linkedIn: 'https://www.linkedin.com/in/geoffvdouden/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'eric-diepeveen',
    name: 'Eric Diepeveen',
    image: '/assets/ericdiepeveen.webp',
    description: 'Venture Partner with expertise in game studio development and investment.',
    detailedDescription: `As an entrepreneur and Venture Partner at ForsVC, Eric brings valuable experience in game studio development and investment. His track record includes founding and leading a game studio, and co-founding Steam Data Suite which was acquired by Newzoo. Having led the development of dozens of games across various platforms and business models, he offers practical guidance in raising capital, building goal-oriented cultures, and avoiding common pitfalls in game development.`,
    expertise: ['Business & Strategy', 'Production & Management'],
    location: 'The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://ericdiepeveen.com/',
    phoneNumber: '',
    email: 'sesameoutlook132@simplelogin.com',
    stages: ['Growth', 'Startup'],
    shortDescription: 'Founder of two game companies, Venture Partner at ForsVC',
    linkedIn: 'https://www.linkedin.com/in/ericdiepeveen/',
    twitter: 'https://twitter.com/ericdiepeveen',
    showOnMobile: true,
    companies: [
      {
        name: 'ForsVC',
        logo: 'forsvclogo.webp',
        website: 'https://fors.vc', // Replace with actual website if available
      },
    ],
  },
  {
    id: 'maarten-de-koning',
    name: 'Maarten de Koning',
    image: '/assets/maarten.webp',
    description: 'Investment expert guiding studios through business development and expansion.',
    detailedDescription: `As Partner and EVP at DDM, Maarten leverages his 17 years of industry experience to guide studios through business development and expansion. His background in investment management and game development, combined with his role overseeing European and Asian markets, makes him particularly valuable for studios seeking international growth. His expertise in investment services and startup advisory, along with his certified Scrum knowledge, enables him to provide comprehensive guidance for studios at any stage of development.`,
    expertise: ['Business & Strategy'],
    location: 'Belgium',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://www.ddmagency.com',
    phoneNumber: '',
    email: 'maarten.dekoning@ddmagency.com',
    stages: [],
    shortDescription: 'Respected Game Industry Executive, Entrepreneur, and Advisor',
    linkedIn: 'https://www.linkedin.com/in/dekoningm/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'richard-kos',
    name: 'Richard Kos',
    image: '/assets/richard.webp',
    description: 'Mobile growth specialist in user acquisition and monetization strategies.',
    detailedDescription: `With over 8 years of experience in AdTech and Gaming Industry, Richard specializes in mobile growth and user acquisition strategies. His work with major companies like Azerion, Playtika, and Huuuge Games has given him deep insights into effective user acquisition approaches. Through his agency Gaming Growth, he helps mobile gaming companies develop and execute targeted growth strategies that deliver measurable results.`,
    expertise: ['Marketing & Community'],
    location: 'Amsterdam, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free'],
    website: 'https://www.gaminggrowth.com',
    phoneNumber: '',
    email: 'richard@gaminggrowth.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Providing User Acquisition expertise for mobile gaming startups',
    linkedIn: '',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'christian-fonnesbech',
    name: 'Christian Fonnesbech',
    image: '/assets/christian.webp',
    description: 'Expert in IP development, narratives, and brand building for games.',
    detailedDescription: `As Head of IP Development at the Leverage Partnership, Christian helps games companies and investors develop lasting IPs, narratives, and brands. His experience includes leadership roles at Nordisk Games and Deck 13, where he helped transform single games into global entertainment brands. With over 50 successful projects across various media types, he specializes in helping studios develop compelling IP strategies, world-building, and franchise development while securing necessary funding and partnerships.`,
    expertise: ['Marketing & Community'],
    location: 'Copenhagen, Denmark',
    languages: ['English'],
    price: ['Paid'],
    website: 'https://www.leveragepartnership.com',
    phoneNumber: '',
    email: 'christian.f@leveragepartnership.com',
    stages: [],
    shortDescription: 'I help game companies build lasting IPs and impactful brands',
    linkedIn: 'https://www.linkedin.com/in/christianfonnesbech/',
    twitter: '',
    showOnMobile: true,
  },
  {
    id: 'rene-otto',
    name: 'René Otto',
    image: '/assets/reneotto.webp',
    description: 'Legal expert in videogame contracts and industry regulation.',
    detailedDescription: `As one of the leading videogame lawyers in the Benelux, René provides expert legal counsel to over 250 developers, publishers, and esports companies. His extensive experience in industry regulation, from loot boxes to copyright legislation, makes him a valuable resource for companies navigating legal challenges. Through his active participation on industry boards and international speaking engagements, he offers comprehensive insights into gaming industry legal frameworks.`,
    expertise: ['Legal & IP'],
    location: 'Halsteren, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://www.deviantlegal.com/',
    phoneNumber: '+31642636446',
    email: 'rene.otto@deviantlegal.com',
    stages: ['Growth', 'Mature'],
    shortDescription: 'Leading video game lawyer in the Benelux',
    linkedIn: 'https://www.linkedin.com/in/renéotto/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'olivier-oosterbaan',
    name: 'Olivier Oosterbaan',
    image: '/assets/olivier.webp',
    description: 'Legal specialist in IP protection and regulatory compliance for game studios.',
    detailedDescription: `As a specialized gaming industry lawyer, Olivier provides expert guidance on contracts, IP protection, copyrights, and regulatory compliance for game studios and publishers. His practical approach focuses on understanding each client's specific needs while applying his extensive legal experience to their situation. He offers comprehensive support from trademark registrations to dispute resolution, making him particularly valuable for studios seeking to protect their interests while growing their business.`,
    expertise: ['Legal & IP'],
    location: 'Amsterdam, The Netherlands',
    languages: ['Dutch', 'English', 'French'],
    price: ['Free', 'Paid'],
    website: 'https://leopoldmeijnenoosterbaan.nl',
    email: 'oosterbaan@lmoadvocaten.nl',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Lawyer with extensive gaming IP experience',
    linkedIn: 'https://www.linkedin.com/in/olivieroosterbaan/',
    showOnMobile: false,
  },
  {
    id: 'nicolas-de-kerchove',
    name: 'Nicolas de Kerchove',
    image: '/assets/nicolasdekerchove.webp',
    description: 'Expert in studio funding rounds and publishing deals.',
    detailedDescription: `Drawing from 15 years of experience as a Game Entrepreneur and Consultant, Nicolas brings extensive expertise in studio funding and publishing deals. His track record includes managing seven gaming studio funding rounds, creating five companies, and overseeing more than 20 game publishing deals. With his extensive industry network and experience working on over 25 games, he provides valuable guidance for studios seeking funding and strategic partnerships in the gaming industry.`,
    expertise: ['Business & Strategy'],
    location: 'Gembloux, Belgium',
    languages: ['English', 'French'],
    price: ['Paid'],
    website: '',
    phoneNumber: '',
    email: 'nicmazy@gmail.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Game entrepreneur and fundraiser',
    linkedIn: 'https://www.linkedin.com/in/nicolasdekerchove/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'sacha-blom',
    name: 'Sacha Blom',
    image: '/assets/sacha.webp',
    description: 'D&I advocate specializing in inclusive hiring and workplace culture.',
    detailedDescription: `As a Diversity & Inclusion advocate in the Dutch game industry, Sacha brings award-winning expertise in inclusive hiring practices and workplace culture development. Her experience implementing successful D&I initiatives at Paladin Studios and her role as a Women in Games ambassador makes her particularly valuable for studios seeking to build diverse teams. Her work bridging industries, including e-sports and immersive tech, provides unique insights into creating inclusive gaming environments.`,
    expertise: ['Business & Strategy'],
    location: 'Utrecht, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: '', // Removing because identical to LinkedIn
    phoneNumber: '',
    email: 'sachablom99@gmail.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Women in Games ambassador and diversity & inclusion advocate',
    linkedIn: 'https://www.linkedin.com/in/sacha-blom-4a40b214a/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'hind-toufga',
    name: 'Hind Toufga',
    image: '/assets/hind.webp',
    description: 'Strategic advisor for international market expansion in gaming.',
    detailedDescription: `As a mentor specializing in public relations, marketing, and business development within the gaming industry, Hind offers strategic guidance for international market expansion, particularly in the Nordic region. Her extensive experience in building international networks and developing business strategies makes her an invaluable resource for companies seeking global growth. Her expertise in strategic partnership management and market entry strategies provides practical value for studios looking to expand their reach.`,
    expertise: ['Business & Strategy', 'Marketing & Community'],
    location: 'Stockholm, Sweden',
    languages: ['English'],
    price: ['Paid'],
    website: '', // Removing because identical to LinkedIn
    phoneNumber: '+46767914806',
    email: 'hinda.toufga@gmail.com',
    stages: ['Growth', 'Startup'],
    shortDescription: 'Business Developer, Sales, Marketing & Partnership Manager, Speaker',
    linkedIn: 'https://www.linkedin.com/in/hind-toufga/',
    twitter: 'https://x.com/toufga',
    showOnMobile: true,
  },
  {
    id: 'tomas',
    name: 'Tomas Sala',
    image: '/assets/tomas.webp',
    description: 'BAFTA-nominated solo developer with expertise in world-building.',
    detailedDescription: `As a BAFTA-nominated artist and creator of The Falconeer and Bulwark: Falconeer Chronicles, Tomas brings unique expertise in solo game development and world-building. His experience creating successful independent games with distinctive artistic visions makes him particularly valuable for developers seeking to craft unique gaming experiences. His background in modding and ability to create personal narratives through epic fantasy worlds offers valuable insights for both solo developers and small teams.`,
    expertise: ['Game Design & Creative', 'Production & Management'],
    location: 'The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://www.thefalconeer.com/contact/about-the-developer/',
    phoneNumber: '',
    email: 'tomas@thefalconeer.com',
    stages: [],
    shortDescription: 'Solo indie game developer. Creator of The Falconeer and Bulwark.',
    linkedIn: 'https://www.linkedin.com/in/tomassala/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'juan',
    name: 'Juan Herrador',
    image: '/assets/juan.webp',
    description: 'Backend technology specialist in games as a service.',
    detailedDescription: `With a decade of specialized experience in backend technology for games, Juan brings deep expertise in supporting games as a service. His background includes creating shared technology for web-based games and implementing comprehensive backend solutions for authentication, analytics, and social features. As a former Director of Technology at GameHouse and current freelance specialist, he helps companies implement robust backend systems for their games, particularly valuable for studios developing live service games.`,
    expertise: ['Technology & Development'],
    location: 'Geldrop, The Netherlands',
    languages: ['English'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '+31626361966',
    email: 'juan.herrador.jimenez@gmail.com',
    stages: ['Growth', 'Mature'],
    shortDescription: 'Experienced game developer focused on live ops and tech',
    linkedIn: 'https://www.linkedin.com/in/juan-herrador-jimenez/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'ata',
    name: 'Ata Sergey Nowak',
    image: '/assets/ata.webp',
    description: 'Studio leader with expertise in creative and business development.',
    detailedDescription: `Drawing from his roots in game modding and professional experience with titles like Hearts of Iron 3, Squad, and Terminal Conflict, Ata brings valuable insights to game development and studio leadership. As Managing Director and Co-Founder of Torpor Games, he offers comprehensive guidance in both creative and business aspects of game development. His experience in consulting and public speaking across the gaming industry makes him particularly valuable for studios seeking to navigate both technical and strategic challenges.`,
    expertise: ['Business & Strategy', 'Game Design & Creative', 'Marketing & Community'],
    location: 'Germany',
    languages: ['English'],
    price: [],
    website: '',
    phoneNumber: '',
    email: 'ata@torporgames.com',
    stages: [],
    shortDescription: 'Managing Director and Co-Founder at Torpor Games.',
    linkedIn: 'https://www.linkedin.com/in/atasergeynowak/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'nicolas-pirot',
    name: 'Nicolas Pirot',
    image: '/assets/nicolas-pirot.webp',
    description: 'Technical Artist specializing in art workflows and pipeline development.',
    detailedDescription: `As Lead Technical Artist at ZA/UM, Nicolas brings extensive expertise in both realistic and non-realistic art styles to his mentoring practice. His contributions to BAFTA-winning projects like Sackboy and his work at Rocksteady demonstrate his mastery of technical art workflows. His comprehensive knowledge of shader solutions, performance optimization, and art pipeline development makes him particularly valuable for teams seeking to enhance their technical art capabilities.`,
    expertise: ['Game Design & Creative', 'Technology & Development', 'Production & Management'],
    location: 'London, UK',
    languages: ['Dutch', 'English', 'French'],
    price: ['Free', 'Paid'],
    website: '', // Removing because identical to LinkedIn
    phoneNumber: '',
    email: 'contact@nicolaspirot.com',
    stages: [],
    shortDescription: 'Lead Technical Artist at ZA/UM',
    linkedIn: 'https://www.linkedin.com/in/nicolaspirot3d/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'teemu',
    name: 'Teemu Haila',
    image: '/assets/teemu.webp',
    description: 'Game industry veteran in development, team building, and company growth.',
    detailedDescription: `As co-founder and CPO of Metaplay and former executive producer at Wooga, Teemu brings extensive experience in game development, team building, and company growth. His leadership in growing the IGDA Finland community and receiving their lifetime award demonstrates his commitment to knowledge sharing and industry development. Drawing from his experience with pioneering projects and successful game launches, he helps mentees navigate both technical and business challenges in game development.`,
    expertise: [
      'Business & Strategy',
      'Game Design & Creative',
      'Production & Management',
      'Technology & Development',
    ],
    location: 'Finland',
    languages: ['English'],
    price: ['Free'],
    website: 'https://haila.fi',
    phoneNumber: '',
    email: 'teemu.haila@gmail.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Co-founder & CPO at Metaplay. Entrepreneur & angel investor.',
    linkedIn: 'https://www.linkedin.com/in/teemuhaila/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'filip',
    name: 'Filip Langerock',
    image: '/assets/filip.webp',
    description: 'Project management expert in gaming and esports.',
    detailedDescription: `With over 12 years of experience in project management and business consultancy, Filip specializes in leveraging technology for successful gaming and ICT projects. His diverse background across transportation and esports sectors provides unique insights into project management and business development. He offers practical guidance in multiple disciplines, from community management to funding strategies, helping studios build sustainable business models.`,
    expertise: ['Business & Strategy', 'Marketing & Community', 'Technology & Development'],
    location: 'De Pinte, Belgium',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '+32472379757',
    email: 'filip@langerockconsulting.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Esports veteran and entrepreneur available to share his knowledge',
    linkedIn: 'https://www.linkedin.com/in/filiplangerock/',
    twitter: 'https://www.twitter.com/filiplangerock',
    showOnMobile: false,
  },
  {
    id: 'chris',
    name: 'Chris Bain',
    image: '/assets/chris.webp',
    description: 'Former Xbox executive specializing in business scale-up programs.',
    detailedDescription: `As founder and CEO of Player One Consulting and former Xbox executive, Chris brings over 25 years of industry experience to his mentoring practice. His expertise in running a successful 10-week business scale-up programme demonstrates his ability to guide companies through critical growth phases. Drawing from his 13+ years at Microsoft and numerous successful scale-up projects, he provides valuable insights into business development, marketing, and funding strategies.`,
    expertise: ['Business & Strategy', 'Marketing & Community'],
    location: 'London, UK',
    languages: ['English'],
    price: ['Paid'],
    website: 'https://playeroneconsulting.com',
    phoneNumber: '',
    email: 'contact@playeroneconsulting.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Former Xbox exec with own games biz consultancy',
    linkedIn: 'https://www.linkedin.com/in/chbain/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'sharath',
    name: 'Sharath Kowligi',
    image: '/assets/sharath.webp',
    description: 'User acquisition expert with experience across 200+ games.',
    detailedDescription: `With extensive experience in user acquisition across over 200 games, including five mega-hits exceeding $100 million in annual revenue, Sharath offers practical insights into mobile game marketing and monetization. His hands-on experience with both successful and unsuccessful projects gives him unique perspective on what works and what doesn't in the mobile gaming space. He specializes in helping developers understand and implement effective user acquisition strategies, particularly for mobile games.`,
    expertise: ['Marketing & Community'],
    location: 'Eindhoven',
    languages: ['Dutch', 'English'],
    price: ['Free'],
    website: '',
    phoneNumber: '+31686320974',
    email: 'sharath.kowligi@gmail.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'User Acquisition Expert & Ad Monetization specialist',
    linkedIn: '',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'tim',
    name: 'Tim Vogel',
    image: '/assets/tim.webp',
    description: 'Marketing lead specializing in mobile gaming and app development.',
    detailedDescription: `As a marketing lead at Playtika and former executive at Data.ai and Spil Games, Tim brings extensive experience in mobile gaming and app development. His expertise spans general game career advice, mobile gaming, marketing and advertising, organizational structure, F2P monetization, startup fundraising, and data-driven growth. Through his mentoring practice, he helps both solo developers and established teams optimize their growth strategies and market presence.`,
    expertise: ['Business & Strategy', 'Marketing & Community'],
    location: 'Amsterdam, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free'],
    email: 'timvogel87@me.com',
    website: '', // Removing because identical to LinkedIn
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Marketing leader - Experienced in growing mobile games & apps.',
    linkedIn: 'https://www.linkedin.com/in/timvogel87',
    showOnMobile: false,
  },
  {
    id: 'marc',
    name: 'Marc Regeur',
    image: '/assets/marc.webp',
    description: 'Business development expert in partnerships and strategic growth.',
    detailedDescription: `As head of business development at Steer Studios and Savvy Games Group, Marc leverages over 15 years of entertainment industry experience to help gaming companies grow. His background at Activision Blizzard and expertise in external partnerships, strategic growth, and project funding across all platforms makes him an ideal mentor for studios seeking to expand their reach. He specializes in guiding developers through partnership development, business initiatives, and competitive gaming opportunities.`,
    expertise: ['Business & Strategy', 'Marketing & Community'],
    location: 'Riyadh, Saudi Arabia',
    languages: ['Dutch', 'English', 'French'],
    price: ['Free', 'Paid'],
    email: 'mregeur@hotmail.com',
    phoneNumber: '+31611365730',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Games industry executive, business development, sales, marketing',
    linkedIn: 'https://www.linkedin.com/in/marcregeur/',
    showOnMobile: false,
  },
  {
    id: 'deloryan',
    name: 'Deloryan Hommers',
    image: '/assets/deloryan.webp',
    description: 'Studio founder focusing on practical entrepreneurship in gaming.',
    detailedDescription: `Drawing from her experience of building a successful game studio from scratch without a traditional game development background, Deloryan offers practical insights into entrepreneurship in the gaming industry. Her approach emphasizes taking action and learning through doing, making her an excellent mentor for aspiring studio founders. As an advocate for diversity in tech, she particularly focuses on inspiring and supporting women entering the game industry and helping studios build diverse teams.`,
    expertise: ['Business & Strategy'],
    location: 'Belgium',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '',
    email: 'deloryan@studiodeloryan.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Founder of Game Studio',
    linkedIn: '',
    showOnMobile: false,
  },
  {
    id: 'isaque',
    name: 'Isaque Sanches',
    image: '/assets/isaque.webp',
    description: 'Senior game designer with diverse AAA and indie experience.',
    detailedDescription: `As a senior game designer at Ubisoft Redlynx, Isaque brings diverse experience across AAA, indie, and mobile game development. His unique background includes founding an arthouse game studio and co-founding a Portuguese indie game development collective, giving him valuable insights into different approaches to game creation. Through his parallel work in interactive performances and installations, he offers mentees a fresh perspective on game design and user interaction.`,
    expertise: ['Game Design & Creative'],
    location: 'Finland',
    languages: ['English'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '',
    email: 'isaque.picao.sanches@gmail.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Game Developer',
    linkedIn: 'https://www.linkedin.com/in/isaquepicaosanches/',
    showOnMobile: false,
  },
  {
    id: 'eva',
    name: 'Eva Maršálková',
    image: '/assets/eva.webp',
    description: 'Project manager creating people-first solutions in tech businesses.',
    detailedDescription: `With over a decade of experience managing large-scale multimedia projects, Eva specializes in creating people-first solutions in tech businesses. Her expertise in leading projects exceeding €1M and focus on human-centered approaches makes her an invaluable mentor for leaders and teams seeking to improve their collaboration and performance. Through her work with DEEP VR, she continues to demonstrate practical applications of her methodologies while helping others create more effective and fulfilling work environments.`,
    expertise: ['Business & Strategy', 'Production & Management'],
    location: 'Woerden, Nederland',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://www.evamarsalkova.com/',
    phoneNumber: '+31624423752',
    email: 'eva@evamarsalkova.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'I empower tech businesses with solutions that put people first.',
    linkedIn: 'https://www.linkedin.com/in/evamarsalkova/',
    showOnMobile: false,
  },
  {
    id: 'nikolina',
    name: 'Nikolina Finska',
    image: '/assets/nikolina.webp',
    description: 'Leadership expert in game industry startups and studio development.',
    detailedDescription: `As a three-time founder with extensive leadership experience in both major corporations and indie studios, Nikolina brings valuable insights to game industry leadership and startup development. Her role as a startup mentor for the European Innovation Council and champion for inclusivity enables her to provide comprehensive guidance on building successful gaming ventures. Her international experience and published work make her particularly suited to help teams navigate the global gaming landscape.`,
    expertise: ['Business & Strategy'],
    location: 'Croatia',
    languages: ['English'],
    price: ['Paid'],
    website: 'https://nikolinawork.com',
    email: 'nikolinafinska@gmail.com',
    shortDescription: '3x founder, international leadership professional',
    linkedIn: 'https://www.linkedin.com/in/nikolinafinska/',
    showOnMobile: false,
  },
  {
    id: 'bruno',
    name: 'Bruno Urbain',
    image: '/assets/bruno.webp',
    description: 'Studio founder with expertise in game design and project management.',
    detailedDescription: `With over two decades of experience in the video game industry, Bruno brings comprehensive expertise in game design, project management, and studio leadership as the founder of Fishing Cactus. His track record of delivering over 60 successful projects across various platforms and business models makes him an invaluable mentor for studios seeking guidance in production and team management. As the founder and president of WALGA, he maintains strong connections within the industry and shares his knowledge through published articles on game design and management.`,
    expertise: ['Business & Strategy', 'Production & Management'],
    location: 'Mons, Belgium',
    languages: ['English', 'French'],
    price: ['Free', 'Paid'],
    website: '', // Removing because identical to LinkedIn
    email: 'bruno.urbain@gmail.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: '20 years of experience leading teams and video game products',
    showOnMobile: false,
  },
  {
    id: 'bob',
    name: 'Bob de Schutter',
    image: '/assets/bob.webp',
    description: 'Game designer specializing in meaningful play and age-friendly design.',
    detailedDescription: `As an award-winning game designer, researcher, and professor at Northeastern University, Bob brings unique expertise in meaningful play and age-friendly game design. His 20+ years of experience as a consultant, developer, and entrepreneur allows him to offer practical guidance across various aspects of game development. Through his company Lifelong Games and extensive speaking engagements, he helps developers create more inclusive and impactful gaming experiences.`,
    expertise: ['Game Design & Creative', 'Marketing & Community', 'Production & Management'],
    location: 'Boston, United States',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    email: 'bobdeschutter6@gmail.com',
    website: 'https://www.bobdeschutter.be',
    shortDescription: 'Game designer and educator advocating for play in later life',
    linkedIn: 'https://www.linkedin.com/in/bobdeschutter',
    twitter: 'https://twitter.com/bobdeschutter',
    showOnMobile: false,
  },
  {
    id: 'mateusz',
    name: 'Mateusz Osiński',
    image: '/assets/mateusz.webp',
    description: 'Investment specialist helping studios connect with publishers.',
    detailedDescription: `As Head of Operations at Agora Gaming Partners, Mateusz specializes in helping new studios develop their projects and connect with publishers. His expertise in gaming investment banking enables him to provide valuable feedback on pitch decks and guide studios through the process of securing funding and partnerships. His focus on early-stage projects makes him particularly valuable for studios just starting their journey in game development.`,
    expertise: ['Business & Strategy'],
    location: 'Warsaw, Poland',
    languages: ['English'],
    price: ['Free'],
    website: 'https://www.linkedin.com/company/agoragamingpartners/?viewAsMember=true',
    phoneNumber: '+48790612555',
    email: 'mateusz@agoragamingpartners.com',
    stages: ['Startup'],
    shortDescription: 'Head of Operations at Agora Gaming Partners, a gaming investment bank.',
    linkedIn: 'https://www.linkedin.com/in/mateusz-osiński-916649143/',
    twitter: 'https://x.com/krakukass',
    showOnMobile: false,
  },
  {
    id: 'christoph',
    name: 'Christoph De Preter',
    image: '/assets/christoph.webp',
    description: 'Legal expert in game company lifecycle and tax shelter programs.',
    detailedDescription: `As a founding partner at EDSON, Christoph provides expert legal guidance for game companies throughout their lifecycle. His experience in securing the Belgian tax shelter program for videogames and representing sector federations before the European court of justice makes him an invaluable resource for studios navigating legal challenges. He offers mentees practical insights into legal matters from incorporation and funding to publishing deals and M&A.`,
    expertise: ['Legal & IP', 'Business & Strategy'],
    location: 'Brussels, Belgium',
    languages: ['Dutch', 'English', 'French'],
    price: ['Free', 'Paid'],
    website: 'https://www.edsonlegal.eu',
    phoneNumber: '+32478368236',
    email: 'christoph.de.preter@edsonlegal.eu',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Leading EU and Belgian videogame lawyer',
    linkedIn: 'https://www.linkedin.com/in/christoph-de-preter-1817a9/',
    showOnMobile: false,
  },
  {
    id: 'espen',
    name: 'Espen Sogn',
    image: '/assets/espen.webp',
    description: 'AAA veteran turned indie studio founder.',
    detailedDescription: `Drawing from 20 years of AAA game development experience working on renowned titles like Killzone and Horizon, Espen now leads Jotun Games as an independent studio founder. His transition from AAA to indie development gives him unique insights to share with developers at various stages of their careers. His current work on The Dark Earth, a roguelite XCOM in a dark fantasy setting, demonstrates his ongoing commitment to innovative game design.`,
    expertise: ['Game Design & Creative', 'Production & Management'],
    location: 'Amsterdam, The Netherlands',
    languages: ['English'],
    price: ['Paid'],
    email: 'espen@jotun-games.com',
    website: 'https://jotun-games.com',
    stages: ['Startup'],
    shortDescription: '20+ years of experience in AAA and now run a studio',
    linkedIn: 'https://www.linkedin.com/in/espensogn/',
    showOnMobile: false,
  },
  {
    id: 'caroline-balemans',
    name: 'Caroline Balemans',
    image: '/assets/caroline.webp',
    description: 'Legal specialist in gaming industry contracts and IP protection.',
    detailedDescription: `Caroline brings extensive legal expertise specifically focused on the gaming industry. As a specialized video game lawyer, she helps developers navigate complex legal challenges including IP protection, contracts, and international business law. Her practical approach to legal matters and deep industry knowledge makes her an invaluable resource for studios seeking to protect their interests while growing their business.`,
    expertise: ['Legal & IP', 'Business & Strategy'],
    location: 'Brussels, Belgium',
    languages: ['Dutch', 'English', 'French'],
    price: ['Free', 'Paid'],
    email: 'caroline.balemans@edsonlegal.eu',
    stages: ['Startup', 'Growth', 'Mature'],
    shortDescription:
      'Specialized video game lawyer helping studios protect and grow their business',
    showOnMobile: true,
  },
  {
    id: 'hendrik',
    name: 'Hendrik Putman',
    image: '/assets/hendrik.webp',
    description: 'Tax expert in R&D incentives for game companies.',
    detailedDescription: `As a Tax Partner at KPMG Belgium, Hendrik specializes in R&D tax incentives with particular expertise in software companies and gaming industry tax structures. His deep understanding of legal structuring and IP planning helps companies optimize their tax positions from the earliest stages of development. His expertise in implementing efficient tax strategies and securing incentives makes him an invaluable resource for studios seeking to maximize their financial efficiency.`,
    expertise: ['Business & Strategy', 'Legal & IP'],
    location: 'Gent, Belgium',
    languages: ['Dutch', 'English', 'French'],
    price: ['Paid'],
    website: 'https://kpmg.com/be/nl/home.html',
    phoneNumber: '+32476815711',
    email: 'hputman@kpmg.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Tax Partner specialized in gaming software tax incentives',
    linkedIn: 'https://www.linkedin.com/in/hendrikputman/',
    showOnMobile: false,
  },
  {
    id: 'patrick',
    name: 'Patrick Gigase',
    image: '/assets/patrick.webp',
    description: 'Business expert in project development and studio operations.',
    detailedDescription: `With comprehensive experience across the video game business ecosystem, Patrick provides expert guidance in project development, negotiations, and studio operations. His expertise spans from setting up new projects and publishing contracts to accounting, tax shelter administration, and IP funding. Having worked with both major and independent studios, he offers practical solutions for business challenges and maintains an extensive network of industry contacts to support developers at any stage.`,
    expertise: ['Business & Strategy', 'Legal & IP'],
    location: 'Antwerp, Belgium',
    languages: ['Dutch', 'English', 'French'],
    price: ['Free', 'Paid'],
    phoneNumber: '+32471483605',
    email: 'patrick@damg.be',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Experienced Benelux Video Game Plumber',
    linkedIn: 'https://www.linkedin.com/in/patrickgigase/',
    showOnMobile: false,
  },
  {
    id: 'viktor',
    name: 'Viktor Stadler',
    image: '/assets/viktor.webp',
    description: 'Project manager specializing in agile game development.',
    detailedDescription: `Drawing from over 15 years in game development, Viktor brings extensive expertise in project management, team leadership, and production methodologies. His experience managing large-scale game projects and implementing agile practices across international teams makes him particularly valuable for studios seeking to improve their production processes. His comprehensive understanding of project planning, risk management, and team development enables him to provide practical guidance for studios at any stage of development.`,
    expertise: ['Production & Management'],
    location: 'Vienna, Austria',
    languages: ['English'],
    price: ['Free'],
    website: '',
    phoneNumber: '',
    email: 'viktor@caketowninteractive.com',
    stages: ['Startup', 'Growth'],
    shortDescription: 'Experienced game producer helping teams deliver successful projects',
    linkedIn: '',
    showOnMobile: true,
  },
  {
    id: 'tom',
    name: 'Tom Jongens',
    image: '/assets/tom.webp',
    description: 'Accelerator founder helping transform creative ideas into ventures.',
    detailedDescription: `As founder of JoTo, a game development accelerator, Tom specializes in helping developers transform their creative ideas into successful ventures. His expertise in operational and business management allows developers to focus on their core creative work. Through his accelerator program, he provides comprehensive support and infrastructure that enables game developers to bring their innovative visions to life.`,
    expertise: ['Business & Strategy'],
    location: 'Belgium',
    languages: ['Dutch', 'English'],
    price: ['Free'],
    website: 'https://www.joto.be',
    phoneNumber: '',
    email: 'tom@joto.games',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription:
      'JoTo is a game development accelerator committed to turning creative ideas into successful ventures.',
    linkedIn: '',
    showOnMobile: false,
  },
  {
    id: 'malcolm',
    name: 'Malcolm Grant',
    image: '/assets/malcolm.webp',
    description: 'Game design director with expertise in hybrid team management.',
    detailedDescription: `With 25 years of experience in game development, Malcolm brings comprehensive expertise from testing to game design direction. His decade of experience working with partners in mobile and mixed reality spaces provides valuable insights into diverse gaming sectors. His current role managing both hybrid and remote teams across multiple time zones, combined with his extensive background in game design implementation, makes him an ideal mentor for teams seeking to improve their development processes.`,
    expertise: ['Game Design & Creative', 'Production & Management'],
    location: 'Belgium',
    languages: ['Dutch', 'English'],
    price: ['Free'],
    website: '',
    phoneNumber: '',
    email: 'msg_rg@hotmail.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: '25 years of games development from Tester to Game Design Director',
    linkedIn: '',
    showOnMobile: false,
  },
  {
    id: 'rafael',
    name: 'Rafael "Lontra" Teixeira',
    image: '/assets/rafael.webp',
    description: 'Studio founder with experience in game localization and porting.',
    detailedDescription: `Drawing from 12 years of industry experience, Rafael brings valuable insights from growing a successful game studio to over 20 team members. As founder of Myth Jeux in Namur, he offers practical guidance for both new and established studios. His expertise in game localization and console porting makes him particularly valuable for studios looking to expand their games into new markets and platforms.`,
    expertise: ['Business & Strategy'],
    location: 'Namur, Belgium',
    languages: ['English', 'French'],
    price: ['Free'],
    website: '',
    phoneNumber: '',
    email: 'rlontra@mitogames.com.br',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription:
      'I have been working in the video game industry for 12 years now, started a company with a friend and we grew to more than 20 during this time, and now I funded Myth Jeux in Namur.',
    linkedIn: '',
    showOnMobile: false,
  },
  {
    id: 'nat',
    name: 'Nat Herman',
    image: '/assets/nat.webp',
    description: 'Game designer specializing in innovative gameplay mechanics.',
    detailedDescription: `I have 10+ years of experience strengthening product strategies and optimising development processes for a range of games studios, from startups through to global brands, and have a proven track record of improving product KPIs, accelerating product pipelines, and establishing organisational user-centricity.

I apply a holistic and tailored approach to cater to the needs and challenges of each organisation. Working cross-functionally, I implement effective data-informed methods and frameworks that streamline processes, foster collaboration, and empower teams to achieve strategic alignment through effective decision-making and problem solving.`,
    expertise: ['Game Design & Creative', 'Technology & Development', 'Production & Management'],
    location: 'Amsterdam, The Netherlands',
    languages: ['English', 'Dutch'],
    price: ['Free'],
    website: '',
    phoneNumber: '',
    email: 'natben18@gmail.com',
    stages: ['Startup', 'Growth'],
    shortDescription:
      'Experienced game designer and developer helping others succeed in the industry',
    linkedIn: 'https://www.linkedin.com/in/nat-herman/',
    showOnMobile: true,
  },
  {
    id: 'geert-nellen',
    name: 'Geert Nellen',
    image: '/assets/geert.webp',
    description: 'Creative director transforming experimental ideas into engaging games.',
    detailedDescription: `As a game designer, artist, and creative director based in the Netherlands, Geert creates games by transforming experimental ideas into engaging experiences. His work includes notable projects like Mini Motorways, Manifold Garden, Viewfinder, and Metrico+. His expertise in puzzle design, narrative design, psychology, team management, and experimental game design makes him particularly valuable for developers seeking to push creative boundaries in their games.`,
    expertise: ['Game Design & Creative', 'Marketing & Community'],
    location: 'The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://geertnellen.com/',
    phoneNumber: '',
    email: 'geert.nellen1@gmail.com',
    stages: ['Growth', 'Mature'],
    shortDescription: 'Game Designer of award winning indie games.',
    linkedIn: 'https://www.linkedin.com/in/geertnellen/',
    showOnMobile: false,
  },
  {
    id: 'olivier-thijssen',
    name: 'Olivier Thijssen',
    image: '/assets/olivier-thijssen.webp',
    description: 'Former studio CEO with expertise in creative team leadership.',
    detailedDescription: `As Co-Founder of Rangatang and former CEO/Creative Director at Ronimo Games, Olivier brings extensive experience in entrepreneurship, leading creative teams, and business development. His expertise spans UI/UX design, 2D/3D game art, marketing, community management, and financial management. Having led Ronimo when it was a 25-35 person studio, he offers valuable insights into quality-focused game development and pragmatic team leadership.`,
    expertise: ['Game Design & Creative', 'Business & Strategy', 'Production & Management'],
    location: 'Utrecht, The Netherlands',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '+31628539212',
    email: 'oli4thijssen@gmail.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Ex-Co-Founder, CEO, Creative Director @ Ronimo Games',
    linkedIn: '',
    showOnMobile: false,
  },
  {
    id: 'toby-allen',
    name: 'Toby Allen',
    image: '/assets/toby-allen.webp',
    description: 'VP of Product at MetaGravity',
    detailedDescription: `Toby Allen has over 20 years of experience in the gaming and immersive industries, with a strong track record in product leadership. He is currently VP of Product at MetaGravity, a next-gen multiplayer technology company. Previously, he was Chief Product Officer at Belgian mobility/fintech startup Skipr, where he helped raise a €7M Series A.
Toby led the HoloLens team at Microsoft EMEA, driving internal product development, customer pilots, and the launch of the Mixed Reality Partner Program, mentoring over 300 agencies. He was also Head of Production at e-learning and games studio Preloaded, and served as Executive Producer at 2K Games and Sumo Digital, working across major open-world, sports, and racing IPs.

A BAFTA member and advisor to the Web3 Fashion Council DAO, Toby is also the founder of Horizan VC, an alternative pre-seed/seed fund backing early-stage UK startups. He taught rapid product development as an Adjunct Professor at UCL's Entrepreneurship Masters program.`,
    expertise: ['Business & Strategy', 'Technology & Development', 'Production & Management'],
    location: 'United Kingdom',
    languages: ['English', 'French'],
    price: ['Free', 'Paid'],
    website: 'https://tobyallen.com',
    phoneNumber: '+447799760970',
    email: 'toby@tobyallen.com',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'VP of Product at MetaGravity',
    linkedIn: 'https://linkedin.com/in/tobyallen',
    showOnMobile: false,
  },
  {
    id: 'nicolas-vereecke',
    name: 'Nicolas Vereecke',
    image: '/assets/nicolas-vereecke.webp',
    description: 'Expert in gaming VC and emergent tech',
    detailedDescription: `Nico has spent his early career working with high-potential gaming founders and leading VC rounds from pre-seed to Series A. He is a Venture Partner at BITKRAFT Verntures and is currently working on an AI entertainment startup. He enjoys nerding out about how business model innovation and new technologies can lead to venture outcomes in gaming.`,
    expertise: ['Business & Strategy'],
    location: 'Belgium',
    languages: ['English', 'Dutch', 'French'],
    price: ['Free', 'Paid'],
    stages: ['Startup', 'Growth'],
    shortDescription:
      'Venture Partner at BITKRAFT Ventures, specializing in gaming VC and AI entertainment',
    linkedIn: 'https://www.linkedin.com/in/nicolasvereecke/',
    showOnMobile: false,
  },
  {
    id: 'yannick-braat',
    name: 'Yannick Braat',
    image: '/assets/yannick.webp',
    description: 'Senior strategist and product leader',
    detailedDescription: `Yannick is the founder and Creative Director of Codename Red, a game studio focused on IP-driven experiences. He has a background as a senior strategist and product leader with over a decade of experience across the gaming, technology, and consulting sectors.
He has held leadership roles at Activision Blizzard and MY.GAMES, where he oversaw global franchise strategy and product portfolio development.
With a foundation in strategy consulting at Gartner and Accenture, he brings a rare blend of creative, commercial, and operational expertise to complex product challenges.`,
    expertise: ['Business & Strategy', 'Production & Management', 'Game Design & Creative'],
    location: 'The Netherlands',
    languages: ['English'],
    price: ['Free', 'Paid'],
    website: '',
    phoneNumber: '',
    email: 'yannick.braat@codenamered.nl',
    stages: ['Growth', 'Mature', 'Startup'],
    shortDescription: 'Senior strategist and product leader',
    linkedIn: 'https://www.linkedin.com/in/ybraat/',
    twitter: '',
    showOnMobile: false,
  },
  {
    id: 'eline-muijres',
    name: 'Eline Muijres',
    image: '/assets/eline.webp',
    description: 'Experienced video game producer with 12+ years in the industry',
    detailedDescription: `Eline Muijres is an experienced video game producer with over 12 years in the industry, working both as a developer producer and a publisher producer. She has produced games across a wide range of genres and platforms, collaborating with teams of varying sizes and budgets to bring creative visions to life. Eline excels at coordinating teams, creating clear roadmaps, milestones, and budgets, and optimizing workflows and production processes.

Additionally, she is an active advocate for inclusivity and diversity within the games industry.`,
    expertise: ['Production & Management', 'Business & Strategy'],
    location: 'Vienna, Austria',
    languages: ['Dutch', 'English'],
    price: ['Free', 'Paid'],
    website: 'https://cohop.games/',
    phoneNumber: '',
    email: '',
    stages: ['Startup', 'Growth', 'Mature'],
    shortDescription: 'Co-founder & Business at Co-hop, former AAA and VR/AR producer',
    linkedIn: 'https://www.linkedin.com/in/elinemuijres/',
    twitter: '',
    showOnMobile: true,
  },
];

// Group mentors by expertise
export const getMentorsByExpertise = (mentors: Mentor[]): Record<string, Mentor[]> => {
  return mentors.reduce((acc: Record<string, Mentor[]>, mentor) => {
    mentor.expertise?.forEach((exp) => {
      if (!acc[exp]) {
        acc[exp] = [];
      }
      acc[exp]?.push(mentor);
    });
    return acc;
  }, {});
};

export default mentors;
